import { Fragment } from 'react'

import { EventStatus } from '~/gamification/types/gamification.types'
import { ProcessedTopic } from '~/components/Drill/DrillTopic/types'
import { getParentQuestIdFromUrl } from '~/gamification/hooks/useGetQuestsForArticle'
import { selectEvents } from '~/gamification/slices/gamification.slice'
import { useAppSelector } from '~/redux/hooks'
import { useGetMultipleChoiceTestsQuery } from '~/redux/apis/multiple-choice-test-api'

import DrillTopicElement from './DrillTopicElement'

export default function DrillTopicElementsList({
  topics,
  drillUrl,
}: {
  topics: ProcessedTopic[] | undefined
  drillUrl: string
}): React.ReactElement | null {
  const events = useAppSelector(selectEvents)
  const parentQuestId = getParentQuestIdFromUrl(drillUrl)
  const { data } = useGetMultipleChoiceTestsQuery({ drillUrl })
  if (topics === undefined) {
    return null
  }

  return (
    <Fragment>
      {topics.map((topic, index) => {
        const { gemstoneOutlineColor, color, i18nKey, splat } = topic.properties

        const isActivity = data?.some(({ url }) => url.endsWith(topic.h1.toLowerCase().split(' ').join('-')))
        const { button, text } = topic.properties.classNames
        const quest = events?.find(
          (event) => event.status === EventStatus.COMPLETED && event.id === `${parentQuestId}#${index}`,
        )

        return (
          <DrillTopicElement
            buttonClassNames={button}
            color={color}
            completed={Boolean(quest)}
            gemstoneOutlineColor={gemstoneOutlineColor}
            gridPosition={topic.gridPosition}
            i18nKey={i18nKey}
            isActivity={isActivity}
            key={topic.path}
            score={quest?.stepsCompleted}
            splatPosition={splat}
            textClassNames={text}
            title={topic.h1}
            url={topic.path}
          />
        )
      })}
    </Fragment>
  )
}
